import JupyterService from './JupyterService';

export default new JupyterService(
    process.env.JUPYTER_HOST ||
    'https://jupyter.stemi.education',
);
